export const DELETE_PROFILE= "@@EDIT_PROFILE/DELETE_PROFILE";
export const PROFILE_HAVE_BEEN_DELETED = "@@EDIT_PROFILE/PROFILE_HAVE_BEEN_DELETED";
export const PROFILE_HAVE_NOT_BEEN_DELETED = "@@EDIT_PROFILE/PROFILE_HAVE_NOT_BEEN_DELETED";
export const SAVE_PASSWORD= "@@EDIT_PROFILE/SAVE_PASSWORD";
export const PASSWORD_HAVE_BEEN_CHANGED = "@@EDIT_PROFILE/PASSWORD_HAVE_BEEN_CHANGED";
export const PASSWORD_HAVE_NOT_BEEN_CHANGED = "@@EDIT_PROFILE/PASSWORD_HAVE_NOT_BEEN_CHANGED";

export const actionCreators = {
    deleteProfile: (payload) => ({
        type: DELETE_PROFILE, 
        payload
    }),
    profileHaveBeenDeleted: () => ({
        type: PROFILE_HAVE_BEEN_DELETED, 
    }),
    profileHaveNotBeenDeleted: (payload) => ({
        type: PROFILE_HAVE_NOT_BEEN_DELETED, 
        payload
    }),
    savePassword: (payload) => ({
        type: SAVE_PASSWORD, 
        payload
    }),
    passwordHaveBeenChanged: () => ({
        type: PASSWORD_HAVE_BEEN_CHANGED,
    }),
    passwordHaveNotBeenChanged: (payload) => ({
        type: PASSWORD_HAVE_NOT_BEEN_CHANGED,
        payload
    }),
}